// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"oP-z","inlineTitle":"pP-z","sponsoredAdsWrapper":"qP-z","marketplaceRecosWrapper":"rP-z"};